import { useEffect, useState } from "react";
import BaseModal, { ModalFooter } from "../base/BaseModal";
import CustomSelect from "../base/CustomSelect";

const UpdateCategoryModal = ({
    isOpen,
    onClose,
    report,
    reportAreas = [],
    onSubmit,
    loading = false,
}) => {
    const [selectedAreaId, setSelectedAreaId] = useState("");
    const [lyDo, setLyDo] = useState("");
    const [error, setError] = useState("");
    const [lyDoError, setLyDoError] = useState("");

    useEffect(() => {
        if (isOpen) {
            setSelectedAreaId(report?.id_linh_vuc_phan_anh || "");
            setLyDo("");
            setError("");
            setLyDoError("");
        }
    }, [isOpen, report]);

    const currentAreaId = report?.id_linh_vuc_phan_anh || "";
    const currentAreaName =
        report?.linh_vuc_phan_anh?.ten ||
        reportAreas.find((a) => a.id === currentAreaId)?.ten ||
        "—";

    const handleSubmit = () => {
        if (!selectedAreaId) {
            setError("Vui lòng chọn lĩnh vực phản ánh");
            return;
        }
        if (selectedAreaId === currentAreaId) {
            setError("Lĩnh vực mới phải khác lĩnh vực hiện tại");
            return;
        }
        if (!lyDo.trim()) {
            setLyDoError("Vui lòng nhập lý do chuyển lĩnh vực");
            return;
        }
        setError("");
        setLyDoError("");
        onSubmit?.(selectedAreaId, lyDo.trim());
    };

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            title="Cập nhật lĩnh vực phản ánh"
            subtitle={report?.ma_phan_anh ? `Mã: ${report.ma_phan_anh}` : ""}
            size="md"
            closeOnOverlay={!loading}
            footer={
                <ModalFooter
                    onCancel={onClose}
                    onSubmit={handleSubmit}
                    submitText="Cập nhật"
                    submitLoading={loading}
                    submitDisabled={loading}
                />
            }
        >
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Lĩnh vực hiện tại
                    </label>
                    <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md text-sm text-gray-700">
                        {currentAreaName}
                    </div>
                </div>

                <div>
                    <label
                        htmlFor="idLinhVucPhanAnh"
                        className="block text-sm font-medium text-gray-700 mb-1"
                    >
                        Lĩnh vực mới <span className="text-red-500">*</span>
                    </label>
                    <CustomSelect
                        id="idLinhVucPhanAnh"
                        value={selectedAreaId}
                        onChange={(val) => {
                            const newId = typeof val === 'object' ? val?.target?.value : val;
                            setSelectedAreaId(newId);
                            if (error) setError("");
                        }}
                        disabled={loading}
                        hasError={Boolean(error)}
                        placeholder="-- Chọn lĩnh vực --"
                        options={reportAreas.map((area) => ({
                            value: area.id,
                            label: area.ten
                        }))}
                    />
                    {error && (
                        <p className="mt-1 text-sm text-red-600">{error}</p>
                    )}
                </div>

                <div>
                    <label
                        htmlFor="lyDoChuyenLinhVuc"
                        className="block text-sm font-medium text-gray-700 mb-1"
                    >
                        Lý do chuyển lĩnh vực <span className="text-red-500">*</span>
                    </label>
                    <textarea
                        id="lyDoChuyenLinhVuc"
                        value={lyDo}
                        onChange={(e) => {
                            setLyDo(e.target.value);
                            if (lyDoError) setLyDoError("");
                        }}
                        disabled={loading}
                        rows={3}
                        maxLength={1000}
                        placeholder="Nhập lý do chuyển sang lĩnh vực mới..."
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed resize-none"
                    />
                    {lyDoError && (
                        <p className="mt-1 text-sm text-red-600">{lyDoError}</p>
                    )}
                </div>
            </div>
        </BaseModal>
    );
};

export default UpdateCategoryModal;
